<template>
  <router-view
    v-if="$auth.check()"
    :key="$route.fullPath"
  />
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapCompanyState, mapActions: mapCompanyActions } = createNamespacedHelpers('company');

export default {
  name: 'Company',
  created() {
    if (this.$route.params.companyId) {
      this.fetchCompanyInitial(this.$route.params.companyId);
    }
  },
  computed: {
    ...mapCompanyState([
      'fetchCompanyInitialPending',
    ]),
  },
  methods: {
    ...mapCompanyActions([
      'fetchCompanyInitial',
    ]),
  },
  watch: {
    $route(to, from) {
      if (from.params.companyId !== to.params.companyId) {
        this.fetchCompanyInitial(to.params.companyId);
      }
    },
  },
};
</script>
